import { IndividualPermissions, PermissionGroupIds, UserSettings } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

export const userFieldValidation = {
    user: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        email: (value: string) => basicValidation.isValidEmail(value, false),
        password: (value: string) => basicValidation.isValidPassword(value),
        firstname: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        middlename: (value: string) => basicValidation.resourceText.isValid(value, true, 100),
        lastname: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        permissionGroupId: (value: string) => PermissionGroupIds.find(pgId => pgId === value) !== undefined,
        initials: (value: string) => validateInitials(value),
        introEmailMessage: (value: string) => basicValidation.resourceText.isValid(value, false, 1000),
        individualPermission: (value: string) => IndividualPermissions.includes(value as typeof IndividualPermissions[number]),
        settings: (value: UserSettings) =>
        {
            if (value === null || value === undefined)
                return false;
            return typeof value.articleContact === 'boolean';
        }
    },

    userRole: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        start: (value: Date) => basicValidation.date(value),
        end: (value: Date) => basicValidation.date(value)
    },

    role: {
        id: (value: string) => basicValidation.resourceId.isValid(value)
    },
};

function validateInitials (value: string): boolean
{
    return typeof value === 'string'
        && value !== null
        && value !== undefined
        && new RegExp("^[A-ZÆØÅ]{1,3}$").test(value);
}